import { IOSSimulatorIcon } from '@compass/Icon'
import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { IdEventV4 } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const simulatorDefinition: SmartSignalDefinition<{ simulator?: IdEventV4['simulator'] }> = {
  key: 'simulator',
  label: 'iOS simulator',
  extract: (e) => ({ simulator: e.simulator }),
  icon(e) {
    const p = this.extract(e)?.simulator
    return (
      <IOSSimulatorIcon
        className={clsx('size-4', {
          'text-red-800': p,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.simulator
    return p === true
  },
  isWeb: () => false,
  isMobile: () => true,
  searchFor: '"simulator":',
  documentationHash: '#ios-simulator-detection',
  urlParamKey: IdentificationUrlKeys.Simulator,
}
